var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mobile_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00846 10.6948C5.00846 10.0762 5.01591 9.45751 5.02339 8.836L5.02339 8.83599C5.02719 8.52089 5.03099 8.20506 5.03384 7.88813C5.03384 4.48283 7.16556 2 10.1094 2H13.8906C16.8344 2 18.9662 4.48283 18.9662 7.88813C18.9915 9.25221 19 10.6163 19 11.9902C19 13.3641 18.9915 14.7478 18.9662 16.1119C18.9662 19.5172 16.8344 22 13.8906 22H10.1094C7.16556 22 5.03384 19.5172 5.03384 16.1021C5.01692 14.8165 5 13.5015 5 12.1668L5.00846 10.6948ZM13.28 19.6402V19.8002C13.28 20.4738 12.7168 21.0002 12 21.0002C11.3003 21.0002 10.72 20.4738 10.72 19.8002V19.6402C10.72 18.9842 11.3003 18.4402 12 18.4402C12.7168 18.4402 13.28 18.9842 13.28 19.6402ZM7.01671 8.44364C7.01136 8.84763 7.00604 9.24974 7.00604 9.65186L7 10.6087C7 11.4762 7.01208 12.331 7.02417 13.1666C7.02417 15.3864 8.54683 17.0002 10.6495 17.0002H13.3505C15.4532 17.0002 16.9758 15.3864 16.9758 13.173C16.994 12.2863 17 11.3869 17 10.4939C17 9.60083 16.994 8.71418 16.9758 7.82753C16.9758 5.61408 15.4532 4.00024 13.3505 4.00024H10.6495C8.54683 4.00024 7.02417 5.61408 7.02417 7.82753C7.02214 8.03354 7.01942 8.23883 7.01671 8.44364Z",
    fill: "#F5F5F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.0e5ca2bb4199291006311c7ee7d2a9e4.svg";
export { ForwardRef as ReactComponent };